module.exports = __webpack_public_path__ + "static/media/RecursosMat-AcessoAoM-med.e542824a.png";